import { Component, inject, model } from '@angular/core';
import { 
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { PasswordReasonDialogData } from '../database-group-info-database.component';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'ms-database-group-info-database-password-dialog',
  imports: [
    MatDialogContent,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle
  ],
  templateUrl: './database-group-info-database-password-dialog.component.html',
  styleUrls: ['./database-group-info-database-password-dialog.component.scss']
})
export class DatabaseGroupInfoDatabasePasswordDialogComponent {
  readonly dialogRef = inject(MatDialogRef<DatabaseGroupInfoDatabasePasswordDialogComponent>);
  readonly data = inject<PasswordReasonDialogData>(MAT_DIALOG_DATA);
  readonly reason = model(this.data.reason);

  onNoClick(): void {
    this.dialogRef.close();
  }
}
